import type React from 'react';

import styled from 'styled-components';
import { theme } from 'app/providers/theme';

export type Props = {
  className?: string;
  fill?: string;
};

const Svg = styled.svg<Props>`
  height: ${({ height }) => height || 'auto'};
  width: ${({ width }) => width || 'auto'};
  fill: ${({ fill }) => fill};
`;

const PoweredByFiit: React.FC<Props> = ({ className, fill = theme.colors.white }) => (
  <Svg
    className={className}
    width="202"
    height="33"
    viewBox="0 0 202 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M71.0509 0.546875H69.6638V32.4513H71.0509V0.546875ZM54.3481 23.462L57.1235 18.6619H55.6335L53.6998 22.188L51.7547 18.6619H50.2646L53.0401 23.462V26.6241H54.3481V23.462ZM48.4208 22.4952C49.0919 22.8478 49.5356 23.4961 49.5356 24.3492C49.5356 25.6687 48.4663 26.6241 47.1469 26.6241H43.7345V18.6619H46.8966C48.182 18.6619 49.2284 19.5946 49.2284 20.8686C49.2284 21.5624 48.9213 22.1312 48.4208 22.4952ZM46.8966 19.8904H45.0426V21.9833H46.8966C47.4767 21.9833 47.9204 21.5283 47.9204 20.9368C47.9204 20.3454 47.4767 19.8904 46.8966 19.8904ZM47.1469 25.3957C47.7611 25.3957 48.2275 24.9066 48.2275 24.281C48.2275 23.6554 47.7611 23.1663 47.1469 23.1663H45.0426V25.3957H47.1469ZM56.7873 10.7132C56.7873 8.48381 55.1721 6.73212 52.9768 6.73212H49.8487V14.6943H52.9768C55.1721 14.6943 56.7873 12.9313 56.7873 10.7132ZM55.5247 10.7132C55.5247 12.2829 54.4896 13.4431 52.9768 13.4431H51.1568V7.98333H52.9768C54.4896 7.98333 55.5247 9.13216 55.5247 10.7132ZM44.4427 13.4431H47.9689V14.6943H43.1346V6.73212H47.912V7.98333H44.4427V10.0535H47.6276V11.2933H44.4427V13.4431ZM38.3313 11.7938L40.0148 14.6943H41.448L39.6394 11.6005C40.5721 11.2251 41.2205 10.3151 41.2205 9.29141C41.2205 7.86958 40.083 6.73212 38.6612 6.73212H35.4763V14.6943H36.7844V11.7938H38.3313ZM36.7844 10.6222V7.96058H38.6612C39.355 7.96058 39.9124 8.54068 39.9124 9.29141C39.9124 10.0308 39.355 10.6222 38.6612 10.6222H36.7844ZM30.0703 13.4431H33.5964V14.6943H28.7622V6.73212H33.5395V7.98333H30.0703V10.0535H33.2552V11.2933H30.0703V13.4431ZM16.1475 6.73212L18.3997 14.6943H19.9125L21.6074 8.88192L23.2908 14.6943H24.8036L27.0558 6.73212H25.6795L24.0074 12.954L22.2102 6.73212H21.0045L19.1959 12.954L17.5239 6.73212H16.1475ZM11.0559 14.8421C8.75828 14.8421 6.92697 13.0222 6.92697 10.7132C6.92697 8.40411 8.75828 6.58417 11.0559 6.58417C13.365 6.58417 15.1849 8.40411 15.1849 10.7132C15.1849 13.0222 13.365 14.8421 11.0559 14.8421ZM11.0559 13.5682C12.6484 13.5682 13.8769 12.3511 13.8769 10.7132C13.8769 9.07521 12.6484 7.85813 11.0559 7.85813C9.4635 7.85813 8.23505 9.07521 8.23505 10.7132C8.23505 12.3511 9.4635 13.5682 11.0559 13.5682ZM5.57356 9.34828C5.57356 7.86958 4.4361 6.73212 2.93465 6.73212H0V14.6943H1.30808V11.9644H2.93465C4.4361 11.9644 5.57356 10.8156 5.57356 9.34828ZM4.26548 9.34828C4.26548 10.1445 3.70812 10.736 2.93465 10.736H1.30808V7.96058H2.93465C3.70812 7.96058 4.26548 8.54068 4.26548 9.34828Z"
      fill={fill}
    />
    <path d="M202 5.28906V7.414H195.127V27.8263H192.889V7.414H186.016V5.28906H202Z" fill={fill} />
    <path d="M180.567 5.28906H182.804V27.8263H180.567V5.28906Z" fill={fill} />
    <path d="M173.2 5.28906H175.438V27.8263H173.2V5.28906Z" fill={fill} />
    <path
      d="M169.374 7.414H158.984V15.7206H168.894V17.8455H158.984V27.8263H156.747V5.28906H169.374V7.414Z"
      fill={fill}
    />
    <path
      d="M136.278 22.8681H145.23V27.8263H131.164V5.28906H145.07V10.2472H136.278V13.982H144.27V18.8758H136.278V22.8681Z"
      fill={fill}
    />
    <path
      d="M122.217 5.28906H127.332V27.8263H123.495L114.864 15.5918V27.8263H109.749V5.28906H113.585L122.217 17.5235V5.28906Z"
      fill={fill}
    />
    <path
      d="M95.2313 28.2785C88.8057 28.2785 83.595 23.1916 83.595 16.5592C83.595 9.92681 88.8057 4.83984 95.2313 4.83984C101.657 4.83984 106.868 9.92681 106.868 16.5592C106.868 23.1916 101.657 28.2785 95.2313 28.2785ZM95.2313 23.256C98.8756 23.256 101.753 20.5837 101.753 16.5592C101.753 12.5347 98.8756 9.86242 95.2313 9.86242C91.5869 9.86242 88.7098 12.5347 88.7098 16.5592C88.7098 20.5837 91.5869 23.256 95.2313 23.256Z"
      fill={fill}
    />
  </Svg>
);

export default PoweredByFiit;
